var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useEffect, useMemo, useState, } from 'react';
import { Button, CustomSelect, Modal } from '@appspotr/ui-kit';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons/faInfoCircle';
import uniqBy from 'lodash/uniqBy';
import { useSelector, useDispatch } from 'react-redux';
import { PATCH_TYPES } from '../SbGlobal/constants';
import { CLChip, CLChipWrapper, CLFormGroup, CLInput, CLLabel, CLModalBody, CLModalFooter, CLModalHeader, CLRadioBox, CLRadioGroup, SelectContainer, TextButton, } from './styles';
import { Banner } from 'containers/AccessControlAPIKeys/styles';
import { cleanPortName } from 'utils/structure';
// import { closeCreateCustomLogiModal } from 'store/structureBuilderUI/actions';
import { selectCreateCustomLogicModalState } from 'store/structureBuilderUI/selectors';
import { changeCreateCustomLogicModalState } from 'store/structureBuilderUI/reducer';
var ModalHeader = function () {
    return _jsx(CLModalHeader, { children: "Create New Custom Logic" });
};
var ModalFooter = function (_a) {
    var onConfirm = _a.onConfirm, onCancel = _a.onCancel;
    return (_jsxs(CLModalFooter, { children: [_jsx(TextButton, __assign({ onClick: onCancel }, { children: "Dismiss" })), _jsx(Button, __assign({ onClick: onConfirm }, { children: "Create Custom Logic" }))] }));
};
var MemoModalHeader = memo(ModalHeader);
var MemoModalFooter = memo(ModalFooter);
export var CreateCustomLogicModal = function (_a) {
    var nodes = _a.nodes, selectedPatches = _a.selectedPatches, patchwork = _a.patchwork, onConfirm = _a.onConfirm;
    var dispatch = useDispatch();
    var _b = useState(''), patchName = _b[0], setPatchName = _b[1];
    var _c = useState(null), modalRef = _c[0], setModalRef = _c[1];
    var _d = useState(false), isSelectedManual = _d[0], setSelectedManual = _d[1];
    var _e = useState([]), outputOptions = _e[0], setOutputOptions = _e[1];
    var _f = useState([]), selectedOutputs = _f[0], setSelectedOutputs = _f[1];
    var isModalOpen = useSelector(selectCreateCustomLogicModalState);
    var populatedSelectedPatches = useMemo(function () {
        var _a, _b;
        return (_b = (_a = nodes
            .filter(function (node) { return selectedPatches.includes(node.id); })
            .map(function (node) { return node.data.patch; })) === null || _a === void 0 ? void 0 : _a.filter(function (node) { return node.type === PATCH_TYPES.LOGIC; })) === null || _b === void 0 ? void 0 : _b.map(function (node) {
            var _a;
            return ((_a = {
                id: node === null || node === void 0 ? void 0 : node.id,
                outputs: node === null || node === void 0 ? void 0 : node.outputs,
                logic: node === null || node === void 0 ? void 0 : node.logic,
            }) !== null && _a !== void 0 ? _a : []);
        });
    }, [nodes, selectedPatches]);
    var isOutGoingEdgesAvailable = useMemo(function () {
        var haveOutgoingEdges = false;
        populatedSelectedPatches.forEach(function (patch) {
            var _a;
            (_a = patch.outputs) === null || _a === void 0 ? void 0 : _a.forEach(function (output) {
                if (patchwork.originalEdges.some(function (edge) {
                    /**
                     * If from_patch is included in the selected patch list and to_patch is not,
                     * it's an outgoing edge
                     */
                    return ((edge === null || edge === void 0 ? void 0 : edge.from_patch) === patch.id &&
                        (edge === null || edge === void 0 ? void 0 : edge.from_arg) === output.name &&
                        !(selectedPatches === null || selectedPatches === void 0 ? void 0 : selectedPatches.includes(edge === null || edge === void 0 ? void 0 : edge.to_patch)));
                }))
                    haveOutgoingEdges = true;
            });
        });
        return haveOutgoingEdges;
    }, [patchwork.originalEdges, populatedSelectedPatches, selectedPatches]);
    var getOutputOptionObj = function (patch, output) { return ({
        output: __assign(__assign({}, output), { patch: patch.id }),
        label: "".concat(patch.logic, " / ").concat(cleanPortName(output.name)),
        value: "".concat(patch.id, ":").concat(output.name),
    }); };
    /**
     * If the selection has at least one out-going edge,
     * only the connected outputs should be available in the options
     */
    var buildOptionsWhenOutGoingEdgesAreAvailable = useCallback(function (optionSource) {
        var _a, _b;
        return (_b = (_a = optionSource === null || optionSource === void 0 ? void 0 : optionSource.outputs) === null || _a === void 0 ? void 0 : _a.filter(function (output) {
            var _a;
            return (_a = patchwork === null || patchwork === void 0 ? void 0 : patchwork.originalEdges) === null || _a === void 0 ? void 0 : _a.find(function (edge) {
                /**
                 * If there is an already defined outgoing edge,
                 * it should be displayed on the modal
                 */
                var isOutgoingEdge = (edge === null || edge === void 0 ? void 0 : edge.from_patch) === optionSource.id &&
                    (edge === null || edge === void 0 ? void 0 : edge.from_arg) === output.name &&
                    !(selectedPatches === null || selectedPatches === void 0 ? void 0 : selectedPatches.includes(edge === null || edge === void 0 ? void 0 : edge.to_patch));
                if (isOutgoingEdge) {
                    /**
                     * Take an extra step to make sure selected options are unique.
                     * It contains duplicates otherwise
                     */
                    setSelectedOutputs(function (prevState) {
                        return uniqBy(__spreadArray(__spreadArray([], prevState, true), [getOutputOptionObj(optionSource, output)], false), 'value');
                    });
                }
                return isOutgoingEdge;
            });
        })) === null || _b === void 0 ? void 0 : _b.map(function (output) { return getOutputOptionObj(optionSource, output); });
    }, [patchwork === null || patchwork === void 0 ? void 0 : patchwork.originalEdges, selectedPatches]);
    /**
     * If the selection doesn't have any outgoing edge,
     * all the exposed outputs should be available in the options
     */
    var buildOptionsWhenOutGoingEdgesAreUnavailable = useCallback(function (optionSource) {
        var _a, _b;
        return (_b = (_a = optionSource === null || optionSource === void 0 ? void 0 : optionSource.outputs) === null || _a === void 0 ? void 0 : _a.filter(function (output) {
            var _a;
            return !((_a = patchwork === null || patchwork === void 0 ? void 0 : patchwork.originalEdges) === null || _a === void 0 ? void 0 : _a.find(function (edge) {
                /**
                 * If both from_patch and to_patch are included in the selected patch list,
                 * it can be considered as an internal edge
                 */
                return ((edge === null || edge === void 0 ? void 0 : edge.from_patch) === optionSource.id &&
                    (edge === null || edge === void 0 ? void 0 : edge.from_arg) === output.name &&
                    (selectedPatches === null || selectedPatches === void 0 ? void 0 : selectedPatches.includes(edge === null || edge === void 0 ? void 0 : edge.to_patch)));
            }));
        })) === null || _b === void 0 ? void 0 : _b.map(function (output) { return getOutputOptionObj(optionSource, output); });
    }, [patchwork === null || patchwork === void 0 ? void 0 : patchwork.originalEdges, selectedPatches]);
    var buildOutputOptions = useCallback(function () {
        var options = isOutGoingEdgesAvailable
            ? populatedSelectedPatches === null || populatedSelectedPatches === void 0 ? void 0 : populatedSelectedPatches.reduce(function (acc, curr) { return __spreadArray(__spreadArray([], acc, true), buildOptionsWhenOutGoingEdgesAreAvailable(curr), true); }, [])
            : populatedSelectedPatches === null || populatedSelectedPatches === void 0 ? void 0 : populatedSelectedPatches.reduce(function (acc, curr) { return __spreadArray(__spreadArray([], acc, true), buildOptionsWhenOutGoingEdgesAreUnavailable(curr), true); }, []);
        setOutputOptions(__spreadArray([], options, true));
    }, [
        buildOptionsWhenOutGoingEdgesAreAvailable,
        buildOptionsWhenOutGoingEdgesAreUnavailable,
        isOutGoingEdgesAvailable,
        populatedSelectedPatches,
    ]);
    var handleOnChangeText = function (_a) {
        var target = _a.target;
        setPatchName(target.value);
    };
    var handleOnChangeOutputs = function (options) {
        setSelectedOutputs(__spreadArray([], options, true));
    };
    var handleOnConfirm = function () {
        onConfirm(patchName, selectedPatches, isSelectedManual
            ? selectedOutputs === null || selectedOutputs === void 0 ? void 0 : selectedOutputs.map(function (option) { return option === null || option === void 0 ? void 0 : option.output; })
            : outputOptions === null || outputOptions === void 0 ? void 0 : outputOptions.map(function (option) { return option === null || option === void 0 ? void 0 : option.output; }));
        setPatchName('');
        dispatch(changeCreateCustomLogicModalState(false));
    };
    useEffect(function () {
        if (selectedPatches) {
            buildOutputOptions();
        }
    }, [buildOutputOptions, selectedPatches]);
    return (_jsx(Modal, __assign({ shouldCloseOnEsc: true, size: 'sm', isOpen: isModalOpen, closeModal: function () { return dispatch(changeCreateCustomLogicModalState(false)); }, contentStyle: { overflow: 'visible' }, header: _jsx(MemoModalHeader, {}), footer: _jsx(MemoModalFooter, { onConfirm: handleOnConfirm, onCancel: function () { return dispatch(changeCreateCustomLogicModalState(false)); } }) }, { children: _jsxs(CLModalBody, __assign({ shrink: isOutGoingEdgesAvailable }, { children: [_jsxs(CLFormGroup, { children: [_jsx(CLLabel, { children: "Custom logic name" }), _jsx(CLInput, { autoFocus: true, value: patchName, onChange: handleOnChangeText })] }), !isOutGoingEdgesAvailable ? (_jsxs(CLFormGroup, { children: [_jsxs(CLRadioGroup, { children: [_jsx(CLRadioBox, { id: "all-outputs", type: "radio", name: "outputs", checked: !isSelectedManual, onChange: function () { return setSelectedManual(false); } }), _jsx(CLLabel, { children: "Select all outputs" })] }), _jsxs(CLRadioGroup, { children: [_jsx(CLRadioBox, { id: "manual-outputs", type: "radio", name: "outputs", checked: isSelectedManual, onChange: function () { return setSelectedManual(true); } }), _jsx(CLLabel, { children: "Select manually" })] }), isSelectedManual && (_jsx(SelectContainer, __assign({ ref: function (ref) { return setModalRef(ref); } }, { children: modalRef && (_jsx(CustomSelect, { options: outputOptions, defaultValue: selectedOutputs, menuPortalTarget: modalRef, multiple: true, isMulti: true, placeholder: "Select state keys...", onChange: handleOnChangeOutputs })) })))] })) : (_jsxs(CLFormGroup, { children: [_jsx(CLLabel, { children: "Outputs" }), _jsx(CLChipWrapper, { children: selectedOutputs === null || selectedOutputs === void 0 ? void 0 : selectedOutputs.map(function (output) { return (_jsx(CLChip, { children: output.label }, output.value)); }) }), _jsx(Banner, { icon: faInfoCircle, type: "warningOutline", multiline: true, description: "The outputs cannot be selected as they have already been connected. Please note that once the connections are established, the outputs are no longer available for selection." })] }))] })) })));
};
